import React, { FunctionComponent } from 'react';
import { Fund } from 'funds-model';
import { FundSmallChart as FundSmallChartBase } from 'ui-components';
import { useFundSmallChartData } from './useFundSmallChartData';

interface FundSmallChartProps {
  fund: Fund;
  unitCategory: string;
  fromDate?: string;
  changeRateKey?: string;
  height?: number;
  changeFromFund?: number;
  noChange?: boolean;
}

const FundSmallChart: FunctionComponent<FundSmallChartProps> = ({
  fund,
  unitCategory,
  fromDate,
  changeRateKey,
  height,
  changeFromFund,
  noChange = false,
}) => {
  const { chartData, isLoading, change } = useFundSmallChartData({
    fundId: fund.id,
    unitCategory,
    fromDate,
    changeRateKey,
    changeFromFund,
  });

  return (
    <FundSmallChartBase
      chartData={chartData}
      isLoading={isLoading}
      changePercent={change}
      noChange={noChange}
      changeRateKey={changeRateKey}
      height={height}
    />
  );
};

export { FundSmallChart };
